export const formatPhone = (digits: string): string => {
    const normalizedDigits = (digits ?? '').replace(/\D/g, '').slice(0, 10);

    if (normalizedDigits.length <= 3) {
        return normalizedDigits;
    }

    if (normalizedDigits.length <= 6) {
        return `${normalizedDigits.slice(0, 3)}-${normalizedDigits.slice(3)}`;
    }

    return `${normalizedDigits.slice(0, 3)}-${normalizedDigits.slice(3, 6)}-${normalizedDigits.slice(6)}`;
};